export default {
      id: "create_template-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#create_template",
      toString: function () {
        return this.url;
      }
    }